//variablen muessen pro instanz angepasst werden
module.exports = {
    mantelUrl : 'https://mantel-api.mobile.documedias.systems/v2/conferences/',
    baseUrl: 'https://mantel-api.mobile.documedias.systems/v2/checkall/',
    baseUrlDownload: 'https://mantel-api.mobile.documedias.systems/v2/downloadall/',
    baseUrlCDN: "https://documedias-188ab.kxcdn.com/",
    api_url : 'https://coredev.api.documedias.systems/api/',
    appointment_api_url : '',//'https://dev.appointment.documedias.systems/api/',
    auth_url : 'https://auth.documedias.com/',
    FILE_SERVER_FOLDER : 'b4222936-3c68-408f-8ca4-f0521bfceabd',
    FILE_SERVER_URL : 'https://fileserver.documedias.systems/',
    VUE_APP_X_API_KEY : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRlIjoiMjAyMS0wMi0yNFQxMzowMzoyOC4zMDZaIiwiaWQiOjE1LCJpYXQiOjE2MTQxNzE4MDh9.s5MUeBBlZCyL1kDeegBSUpn7X0FelPnGlGg1pMbxu7c',
    vue_app_access_key : 'eyJhbGciOiJIUzM4NCIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjo5LCJjb25ncmVzc0lkIjoxLCJkYXRlIjoiMjAxOC0xMC0wMVQwOTo0Njo0MC42MDlaIiwiaWF0IjoxNTM4Mzg3MjAwfQ.1Z8vRJF2gZtCuLDEWxQhNyvlYHS6YZsdJxvoYGfyo112afY8CofuEBP4_jvIPXhc',
    cdnInitStamp: "2026-08-12T11:03:00.000Z",//"2025-03-28T16:10:00.000Z"
    conference: '1577',
    short_name: 'eec2026',
    full_name: 'EEC 2026',
    api_version: 2, //change this to api version 2 for new conferences!!!
    conf_date : '26 – 30 May',
   //APP
    auth_key : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjozNTkyLCJjb25ncmVzc0lkIjoxNTc3LCJkYXRlIjoiMjAyNi0wNi0wMVQxMzoxMjozNS40NTlaIiwiaWF0IjoxNzgwMzE5NTU1fQ._6h4TrbHEF6VUkrWAtWFoHu5I6XEKcHWCAB3JKr80YM',
    auth_dev_key : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjozNTkxLCJjb25ncmVzc0lkIjoxNTc3LCJkYXRlIjoiMjAyNi0wNi0wMVQxMzoxMjoxMS4xNzNaIiwiaWF0IjoxNzgwMzE5NTMxfQ.YST_bZWXsS0EoR5da0pilus__K3R1ZE7yecf2bH7dXM',
    auth_dev_key_web : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBsaWNhdGlvbklkIjozMzYxLCJjb25ncmVzc0lkIjoxNTYzLCJkYXRlIjoiMjAyNi0wMS0yNlQxMjo0NDowMi44ODNaIiwiaWF0IjoxNzY5NDMxNDQyfQ.JHC5BT3akskGsi0IUFJNCkFI4Tj0cN7mI47gjKcv52U',
    chat_url: 'https://eec2026.chat.documedias.systems/api/',
    favorite_api_url: 'https://eec2026.planner.documedias.systems/api/program/favorites',
    is_multi_conf_app: false, //set true for society or Conf2Go,
    secret_mf:'k3HM1qRe0K+0QX+Eq2JmDV+dTJKnhiQXxu3+7ORwbpA=',
    secret_bluedog: 'ITplW37I+q4g2ZevmHn5x]u0Ayf+oIoMJ6j7ENBar96VI',
    update_user_extra_url : 'https://userextra.cpa.documedias.com',
    main_color: '#61AFC4',
    is_app: false, //unbedingt anpassen bevor App deploy
    versionIOS:'v1.0.1 5',
    versionAndroid:'v1.0.1 5',
    loginRequired: true,
    hasMenuBar:false,
    appdata_version: '_v5',
    database_version: 'v5',
    //enable chat routes and show chat link icon in menu
    chat_enabled: false,
    networking_enabled: false,
    has_menulogo: false, 
    //menulogo.png icon in menu bar or just conference name
    interactive_url: 'https://eec2026.mobile.documedias.com/interactive',
    eposterviewer_link: 'https://eec2026.abstractserver.com/eposter/#/viewer/',
    contact_us_mail: 'eec2026.abstracts@abstractserver.com',
    privacy_policy_link: 'https://www.ilae.org/privacy-and-security',
}
